"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var ClickOutsideDetector_1 = require("../ClickOutsideDetector");
var react_portal_1 = require("react-portal");
var md_1 = require("react-icons/md");
var react_transition_group_1 = require("react-transition-group");
var getSize_1 = require("../getSize");
var getPosition_1 = require("../getPosition");
var Input_1 = require("../Input");
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.optionsRef = React.createRef();
        _this.state = {
            x: 0,
            y: 0,
            width: 'auto',
            toggle: false,
            optionsScrollY: 0,
        };
        _this.handleOptionsPopupScroll = function (e) {
            if (_this.optionsRef.current) {
                _this.setState({ optionsScrollY: _this.optionsRef.current.scrollTop });
            }
        };
        _this.updatePopup = function () {
            if (_this.ref.current) {
                var current = _this.ref.current;
                var _a = current.getBoundingClientRect(), width = _a.width, height = _a.height;
                var _b = getPosition_1.getPosition(current), x = _b.x, y = _b.y;
                _this.setState({ x: x + 1, y: y + height + 5, width: width });
            }
            if (_this.optionsRef.current) {
                var findOptionIndex = _this.props.options.findIndex(function (_a) {
                    var id = _a.id;
                    return id === _this.props.value;
                });
                if (_this.state.toggle && findOptionIndex !== -1) {
                    var findElement = _this.optionsRef.current.children[findOptionIndex];
                    var scrollTop = _this.optionsRef.current.scrollTop;
                    _this.optionsRef.current.scrollTop = getPosition_1.getPosition(findElement).y - _this.state.y - scrollTop;
                }
                else {
                }
            }
        };
        _this.onChange = function (id) {
            if (_this.props.selectType === 'multiple') {
                var value = _this.props.value;
                var findValueIndex = value.indexOf(id);
                var nextValue = value.slice();
                if (findValueIndex === -1) {
                    nextValue.push(id);
                }
                else {
                    nextValue.splice(findValueIndex, 1);
                }
                _this.props.onChange(nextValue);
            }
            else {
                _this.setState({ toggle: false }, function () {
                    if (_this.props.selectType === 'nullable') {
                        _this.props.onChange(_this.isSelected(id) ? null : id);
                    }
                    else if (_this.props.selectType !== 'multiple') {
                        _this.props.onChange(id);
                    }
                });
            }
        };
        _this.updateSize = function (props) {
            if (props === void 0) { props = _this.props; }
            var optionNames = props.options.map(function (_a) {
                var name = _a.name;
                return name;
            });
            var words = optionNames.slice();
            if (typeof props.placeholder === 'string') {
                words.push(props.placeholder);
            }
            _this.setState({ width: getSize_1.getSize(words) + 50 });
        };
        _this.isSelected = function (id) {
            if (_this.props.selectType === 'multiple') {
                return _this.props.value.includes(id);
            }
            else {
                return _this.props.value === id;
            }
        };
        _this.isEmptyValue = function () {
            return _this.props.selectType === 'multiple' ? _this.props.value.length <= 0 : _this.props.value === null;
        };
        _this.getName = function () {
            if (_this.props.selectType === 'multiple') {
                var _a = _this.props, value_1 = _a.value, options = _a.options;
                return options
                    .filter(function (_a) {
                    var id = _a.id;
                    return value_1.includes(id);
                })
                    .map(function (_a) {
                    var name = _a.name;
                    return name;
                })
                    .join(', ');
            }
            else {
                var _b = _this.props, value_2 = _b.value, options = _b.options;
                var findSelectedValue = options.find(function (_a) {
                    var id = _a.id;
                    return id === value_2;
                });
                return findSelectedValue && findSelectedValue.name;
            }
        };
        _this.onClickOut = function () {
            _this.setState({ toggle: false });
        };
        _this.handleToggle = function () {
            _this.setState({ toggle: !_this.state.toggle }, function () {
                _this.updatePopup();
            });
        };
        return _this;
    }
    Select.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.updateSize();
            _this.updatePopup();
        });
        window.addEventListener('resize', this.updatePopup);
    };
    Select.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updatePopup);
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.state, x = _a.x, y = _a.y, width = _a.width, toggle = _a.toggle;
        var _b = this.props, options = _b.options, placeholder = _b.placeholder, className = _b.className, error = _b.error;
        var optionItems = options.map(function (_a, key) {
            var id = _a.id, name = _a.name;
            var isSelected = _this.isSelected(id);
            return (React.createElement("div", { key: key, className: classnames_1.default(styles.option, isSelected && styles.isSelected), onClick: function () {
                    _this.onChange(id);
                } },
                isSelected && React.createElement(md_1.MdCheck, { className: styles.itemIcon }),
                React.createElement("div", { className: styles.inner }, name)));
        });
        var isEmpty = this.isEmptyValue();
        return (React.createElement("div", { ref: this.ref, style: {
                width: width,
            }, className: classnames_1.default(styles.select, className, toggle && styles.isActivated, isEmpty && styles.isEmpty) },
            React.createElement("div", { "data-name": "select-input", className: styles.input, onClick: this.handleToggle }, isEmpty ? placeholder : this.getName()),
            React.createElement(md_1.MdArrowDropDown, { className: styles.icon }),
            typeof error === 'string' && error && (React.createElement(Input_1.ErrorMessage, { className: styles.error, message: error })),
            React.createElement(react_portal_1.Portal, null,
                React.createElement(ClickOutsideDetector_1.default, { ignore: [this.ref], onClickOutside: this.onClickOut },
                    React.createElement(react_transition_group_1.CSSTransition, { in: toggle, unmountOnExit: true, timeout: 600, classNames: {
                            enter: styles.enter,
                            enterActive: styles.enterActive,
                            exit: styles.exit,
                            exitActive: styles.exitActive,
                        } },
                        React.createElement("div", { "data-name": "select-options", style: { left: x, top: y, width: width }, onScroll: this.handleOptionsPopupScroll, className: styles.options, ref: this.optionsRef }, optionItems))))));
    };
    return Select;
}(React.Component));
exports.default = Select;
